import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Nav.module.css';
import logo from '../../assets/mino_logo.png';
import telegramIcon from '../../assets/telegram.svg';
import twitterIcon from '../../assets/twitter.svg';
import { useNavigate } from 'react-router-dom';
import useStore from '../../hooks/useStore';

const Nav = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  const { 
    address,
    isWalletMenuOpen,
    formatAddress,
    connectWithChainSwitch,
    disconnect,
    toggleWalletMenu,
    closeWalletMenu,
    initWalletListeners,
    autoConnect
  } = useStore();

  const handleConnect = async () => {
    try {
      await connectWithChainSwitch(() => {
        console.log('NFT detected, navigating to dashboard...');
        navigate('/dashboard');
      });
    } catch (error) {
      console.error('Connection failed:', error);
    }
  };

  const handleWalletClick = () => {
    if (!address) {
      handleConnect();
    } else {
      toggleWalletMenu();
    }
  };

  const handleClickOutside = useCallback((e) => {
    if (!e.target.closest(`.${styles.walletContainer}`)) {
      closeWalletMenu();
    }
  }, [closeWalletMenu]);

  useEffect(() => {
    const init = async () => {
      try {
        await autoConnect(() => {
          navigate('/dashboard');
        });
      } catch (error) {
        console.error('Auto connect failed:', error);
      }
    };

    init();
    initWalletListeners(navigate);

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [handleClickOutside, navigate, autoConnect, initWalletListeners]);

  return (
    <nav className={styles.nav}>
      <div className={styles.navContainer}>
        <div className={styles.leftSection}>
          <img src={logo} alt="logo" className={styles.logo} />
        </div>
        <div className={styles.rightSection}>
          <div className={styles.socials}>
            <a href="https://x.com/TetrisBNB" target="_blank" rel="noopener noreferrer" className={styles.socialLink}>
              <img src={twitterIcon} alt="Twitter" className={styles.socialIcon} />
            </a>
            <a href="https://t.me/TetrisBNB" target="_blank" rel="noopener noreferrer" className={styles.socialLink}>
              <img src={telegramIcon} alt="Telegram" className={styles.socialIcon} />
            </a>
          </div>
          
          <div className={styles.walletContainer}>
            <button onClick={handleWalletClick} className={styles.walletButton}>
              {!address ? (
                t('nav.connect')
              ) : (
                <>
                  <span>{formatAddress(address)}</span>
                  <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    height="24px" 
                    viewBox="0 -960 960 960" 
                    width="24px" 
                    fill="#FFF"
                    className={`${styles.arrowIcon} ${isWalletMenuOpen ? styles.arrowUp : ''}`}
                  >
                    <path d="M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z"/>
                  </svg>
                </>
              )}
            </button>
            {isWalletMenuOpen && address && (
              <div className={styles.walletMenu}>
                <button onClick={disconnect}>Disconnect</button>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Nav;